/* Kontura gallery filter.
   Shopify allows only ONE variant image per variant, and that slot is already
   taken by the colour (Chromstahl / Schwarz). To still show option-specific
   photos — e.g. only the white cable when "Kabel: Weiss" is picked — tag the
   image's alt text in the admin with a marker:

     Kabel in Weiss – Standardausführung #Kabel_Weiss

   Format: #<Optionsname>_<Optionswert>, at the end of the alt text.
   Untagged images always stay visible. The marker is stripped from the alt
   attribute here, so screen readers never read it out.

   The theme re-renders the gallery whenever the variant image changes, so this
   keeps no state between runs: every pass re-reads the DOM from scratch. */

(() => {
  const MARKER = /\s*#([^\s#_]+)_([^#]+)\s*$/;
  const ITEMS = '.product__media-item, .thumbnail-list__item, .product-media-modal__content [data-media-id]';

  /* Move the marker from the alt text onto the element, once per element.
     After a re-render the fresh markup carries the marker again, so this
     simply runs anew on the new nodes. */
  const tag = (scope) => {
    for (const item of scope.querySelectorAll(ITEMS)) {
      if (item.dataset.konturaOption) continue;

      const img = item.tagName === 'IMG' ? item : item.querySelector('img');
      const match = img?.alt?.match(MARKER);
      if (!match) continue;

      item.dataset.konturaOption = match[1].trim().toLowerCase();
      item.dataset.konturaValue = match[2].trim().toLowerCase();
      img.alt = img.alt.replace(MARKER, '').trim();
    }
  };

  /* Currently selected option values, keyed by lowercased option name. */
  const selection = (scope) => {
    const map = {};
    const picker = scope.querySelector('variant-selects');
    if (!picker) return map;

    for (const fieldset of picker.querySelectorAll('fieldset')) {
      const legend = fieldset.querySelector('legend');
      const checked = fieldset.querySelector('input:checked');
      if (!legend || !checked) continue;
      // First text node only — the theme may append a span with the current value.
      const name = (legend.firstChild?.textContent || legend.textContent).trim().toLowerCase();
      map[name] = checked.value.trim().toLowerCase();
    }

    for (const select of picker.querySelectorAll('select')) {
      const label = select.closest('.product-form__input')?.querySelector('.form__label');
      if (label) map[label.textContent.trim().toLowerCase()] = select.value.trim().toLowerCase();
    }

    return map;
  };

  /* If the slide on screen just got hidden, move to the first visible one so
     the gallery never shows a blank frame. */
  const restoreActiveSlide = (scope) => {
    const gallery = scope.querySelector('media-gallery');
    const active = scope.querySelector('.product__media-item.is-active');
    if (!gallery?.setActiveMedia || !active?.classList.contains('hidden')) return;

    const next = scope.querySelector('.product__media-item:not(.hidden)');
    if (next) gallery.setActiveMedia(next.dataset.mediaId, true);
  };

  const filter = () => {
    for (const list of document.querySelectorAll('.product__media-list')) {
      const scope = list.closest('[id^="shopify-section"]') || document;
      const picked = selection(scope);
      let touched = false;

      // The zoom modal renders the same media again but sits outside the section.
      const key = scope.id?.replace(/^shopify-section-/, '');
      const modal = key ? document.getElementById(`ProductModal-${key}`) : null;

      for (const area of modal ? [scope, modal] : [scope]) {
        tag(area);

        for (const item of area.querySelectorAll('[data-kontura-option]')) {
          const wanted = picked[item.dataset.konturaOption];
          // Unknown option (e.g. a typo in the marker) — leave the image visible.
          const matches = wanted === undefined || wanted === item.dataset.konturaValue;
          item.classList.toggle('hidden', !matches);
          touched = true;
        }
      }

      if (!touched) continue;
      restoreActiveSlide(scope);
      scope.querySelectorAll('slider-component').forEach((s) => s.initPages?.());
    }
  };

  const schedule = () => requestAnimationFrame(filter);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', filter);
  } else {
    filter();
  }

  // The picker fires change; the theme then re-renders and publishes variantChange.
  document.addEventListener('change', (event) => {
    if (event.target.closest?.('variant-selects')) schedule();
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, schedule);
    subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, schedule);
  }

  document.addEventListener('shopify:section:load', schedule);
})();
